// Purpose: small, consistent link to the /notice page for shell footers.
import { Link } from 'react-router-dom';

export function NoticeLink({ className }: { className?: string }) {
  return (
    <Link
      to="/notice"
      className={[
        'text-body-s text-fg-muted hover:text-fg-secondary underline',
        className ?? '',
      ].join(' ')}
    >
      Privacy &amp; Terms
    </Link>
  );
}
